(function () {
    "use strict";

    try {

        var checkoutUrl = "checkout.louloungerie.com";

        var preLoadImgPath = [
            "/Assets/images/loading.gif",
            "/Assets/images/stripe.svg",
            "/Assets/images/easypie.svg",
            "/Assets/images/404.svg",
            "/Assets/images/404.png",
            "/Assets/images/receipt.svg",
            "/Assets/images/receipt2.svg",
            "/Assets/images/link.svg",
            "/Assets/images/bag.svg",
            "/Assets/images/bag2.svg",
            "/Assets/images/error.svg",
            "/Assets/images/shipping.svg",
            "/Assets/images/del.svg",
            "/Web/logo.jpg",
            "/Web/icon.png"
        ];

        var preLoadImg = preLoadImgPath.map(function (p) {
            return "https://" + checkoutUrl + p;
        });

        function addLinkOnce(rel, href, crossOrigin) {
            try {

                if (document.querySelector('link[rel="' + rel + '"][href="' + href + '"]')) return;

                var link = document.createElement("link");
                link.rel = rel;
                link.href = href;

                if (crossOrigin) link.crossOrigin = "anonymous";

                document.head.appendChild(link);

            } catch (e) { }
        }

        function warmupConnection() {
            try {

                addLinkOnce("dns-prefetch", "//" + checkoutUrl);
                addLinkOnce("preconnect", "https://" + checkoutUrl, true);

            } catch (e) { }
        }

        function warmupImages() {
            try {

                if (window.location.hostname.endsWith(checkoutUrl)) return;

                preLoadImg.forEach(function (url) {

                    try {

                        fetch(url, {
                            mode: "no-cors",
                            credentials: "omit",
                            cache: "force-cache"
                        }).catch(function () { });

                    } catch (e) { }

                });

            } catch (e) { }
        }

        function run() {
            try {

                warmupConnection();
                warmupImages();

            } catch (e) { }
        }

        function schedule() {
            try {

                if ("requestIdleCallback" in window) {
                    window.requestIdleCallback(run, { timeout: 5000 });
                } else {
                    setTimeout(run, 1200);
                }

            } catch (e) { }
        }

        if (document.readyState === "complete") {
            schedule();
        } else {
            window.addEventListener("load", schedule);
        }

    } catch (e) { }

})();